import {
  useGetCheckPsp,
  usePostKycTierOne,
  usePostKycTierOneAndTwo,
} from '@olxeu-a2b/delivery-utils/src/hooks';
import { useEffect } from 'react';
import { PSP_TYPE } from '../../../constants';

const headersForRequest = {
  'X-OLX-Tenant-ID': 'olx-pl',
  'X-OLX-Correlation-ID': String(new Date().getTime()),
};

export const usePspLogicForKyc = (shouldFetch?: boolean) => {
  const [getCheckPsp, response, isLoading, isError] = useGetCheckPsp();
  const [postKycTierOne] = usePostKycTierOne();
  const [postKycTierOneAndTwo, postKycTierOnAndTwoResponse] = usePostKycTierOneAndTwo();
  const isTiersArray = () => Array.isArray(response?.data?.tiers);
  const isPspPayu = response?.data?.psp === PSP_TYPE.PAYU;
  const isSellerAccountNonExistent = isTiersArray() && response?.data?.tiers?.includes(0);
  const payuSellerType = response?.data?.sellerType;
  const isSellerOnPayuTierOne = isPspPayu
    ? isTiersArray() && response?.data?.tiers?.includes(1)
    : false;
  const isSellerOnPayuTierTwo = isPspPayu
    ? isTiersArray() && response?.data?.tiers?.includes(2)
    : false;
  const redirectUrlForTierTwo = postKycTierOnAndTwoResponse?.data?.redirectUrl;

  useEffect(() => {
    if (shouldFetch) {
      getCheckPsp(headersForRequest);
    }
  }, [shouldFetch]);

  const handlePostKyc = (data: { iban: string; birthDate?: string | null; returnUrl?: string }) => {
    const shouldPostKycTierOne = isSellerOnPayuTierOne && !isSellerOnPayuTierTwo;
    const shouldPostKycTierOneAndTwo = isSellerOnPayuTierOne && isSellerOnPayuTierTwo;

    if (shouldPostKycTierOne) {
      postKycTierOne({
        headers: headersForRequest,
        data: { iban: data.iban, birthDate: data.birthDate },
      });
    }

    if (shouldPostKycTierOneAndTwo) {
      postKycTierOneAndTwo({
        headers: headersForRequest,
        data,
      });
    }
  };

  return {
    response,
    redirectUrlForTierTwo,
    isSellerOnPayuTierOne,
    isSellerOnPayuTierTwo,
    isSellerAccountNonExistent,
    payuSellerType,
    isLoading,
    isError,
    handlePostKyc,
  };
};

export default usePspLogicForKyc;
